export default "__VITE_ASSET__B2CAAaoR__"